export enum TransporterConfigurationEnum {
  ACTIVATION_LDM = 'ACTIVATION_LDM',
  ACTIVATION_FLEXIBILITY_DEADLINE = 'ACTIVATION_FLEXIBILITY_DEADLINE',
  ACTIVATION_IMPORT_CUSTOMER = 'ACTIVATION_IMPORT_CUSTOMER',
  ACTIVATION_INIT_VIREMENT = 'ACTIVATION_INIT_VIREMENT',
  ACTIVATION_REFUND_TRANSPORT = 'ACTIVATION_REFUND_TRANSPORT',
  ACTIVATION_SALE_SUPPORT = 'ACTIVATION_SALE_SUPPORT',
  EXPORT_BILL_FTP_ACTIVATION = 'EXPORT_BILL_FTP_ACTIVATION',
  EXPORT_BILL_FTP_HOST = 'EXPORT_BILL_FTP_HOST',
  EXPORT_BILL_FTP_PORT = 'EXPORT_BILL_FTP_PORT',
  EXPORT_BILL_FTP_LOGIN = 'EXPORT_BILL_FTP_LOGIN',
  EXPORT_BILL_FTP_PASSWORD = 'EXPORT_BILL_FTP_PASSWORD',
  EXPORT_BILL_FTP_BILLS_PATH = 'EXPORT_BILL_FTP_BILLS_PATH',
  EXPORT_BILL_FTP_ACCOUNTINGS_PATH = 'EXPORT_BILL_FTP_ACCOUNTINGS_PATH',
  EXPORT_BILL_FTP_ZIPPED = 'EXPORT_BILL_FTP_ZIPPED',
  FUEL_INDEXATION_STRATEGY = 'FUEL_INDEXATION_STRATEGY',
}
